// extracted by mini-css-extract-plugin
export var addButton = "_ds-0";
export var border = "_ds-8";
export var check = "_ds-h";
export var danger = "_ds-6";
export var dropdownContainer = "_ds-1";
export var editModalBody = "_ds-j";
export var footerContainer = "_ds-i";
export var fullWidth = "_ds-a";
export var hide = "_ds-9";
export var icon = "_ds-3";
export var input = "_ds-7";
export var inputFlex = "_ds-b";
export var inputWrapper = "_ds-c";
export var manualFocus = "_ds-5";
export var optionButton = "_ds-4";
export var pillWrapper = "_ds-e";
export var pointer = "_ds-2";
export var showOverflow = "_ds-f";
export var tagsFlex = "_ds-d";
export var xButton = "_ds-g";